import { render, staticRenderFns } from "./AppSettingsDialog.vue?vue&type=template&id=2341fc7a"
import script from "./AppSettingsDialog.vue?vue&type=script&lang=js"
export * from "./AppSettingsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports